/**
 * P2P Connect is a wrapper around redux-react/connect
 * that ALWAYS uses our local store, so that when we use
 * our components in other apps, they use our locale store
 * instead of the containing apps store.
 */

import React from 'react'
import { connect, useSelector, useDispatch, useStore, batch } from 'react-redux' // eslint-disable-line no-restricted-imports
import store from '../stores/configureStore'

// special connect() function that locks in the store
const p2pConnect = (...args) => {
  const wrappedConnect = WrappedComponent => {
    const ConnectedWrappedComponent = connect(...args)(WrappedComponent)
    const connectedElement = props => (
      <ConnectedWrappedComponent {...props} store={store} />
    )
    return connectedElement
  }
  return wrappedConnect
}

export { p2pConnect as connect, useSelector, useDispatch, useStore, batch }
